export * from "./value-proposition-animation";
